export const UPDATE_ACTION_BAR = "UI/ACTION_BAR/UPDATE";
